module.exports = __webpack_public_path__ + "img/archive.16bd0082.svg";